// extracted by mini-css-extract-plugin
export default {"icon":"Skills_icon__OQQbq","list":"Skills_list__FyGtr"};